import controller from './dynamic-banner.controller';
import template from './dynamic-banner.view.html';

let DynamicBannerComponent = {
  template,
  controller,
  bindings : {
    dbData : '<',
    dbName : '<'
  }
};

export default DynamicBannerComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/shared/components/banners/dynamic-banner/dynamic-banner.component.js
 **/